
import { ModalProps } from '../models';
import {ReactComponent as DeleteIcon} from '../../../images/nde-icon-delete.svg';
import './ComingSoonModal.scss';
import ReactModal from 'react-modal';
import { useSelector } from 'react-redux';
import { selectControls } from '../../../redux/controls';


export const ComingSoonModal = ({open, onClose}: ModalProps): JSX.Element => {
  const controls = useSelector(selectControls);

  return (
    <>
      {
        open &&
        <ReactModal
          isOpen={open}
          className="nqt-modal nqt-sys-req-modal"
          overlayClassName="nqt-modal-overlay"
          shouldFocusAfterRender={true}
          shouldReturnFocusAfterClose={true}
          contentLabel={'ComingSoon'}
        >
          <div className='nqt-modal--container'>
            <div className="nqt-modal--header-group">
              <header className='nqt-modal--title'>{'ComingSoon'}</header>
              <button className='nqt-modal--close-button'
                ref={(el) => el?.focus()}
                onClick={() => onClose(false)}>
                <DeleteIcon/>
                <span className="visually-hidden">{controls?.ModalClose?.controlText}</span>
              </button>
            </div>
            <div className="nqt-modal--border">
              <section className="nqt-modal--content">
                <span className="title_sm">ComingSoon:</span>
                
              </section>
            </div>
          </div>
        </ReactModal>
      }
    </>
  );
};

export default ComingSoonModal;